module.exports = "./img/1f377a82ceefec7052ec8e2dfdfacded.jpg";